import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_SEARCH_PAGE } from "@/settings/constant";
import { Button } from "@bookips/solvook-ui-library";
import { Box, Typography, styled, useTheme } from "@mui/material";
import { useMemo, useRef } from "react";
import { SubjectsWithString } from "src/api/product";
import SwiperCore, { A11y, Autoplay, EffectCoverflow, Grid, Navigation, Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { BookCard } from "../../Landing/BookCard";
import { ManualCurationSectionWrapper } from "../../Landing/ManualCurationSection";
import { SwiperCustomButton } from "../../Landing/SwiperCustomButton";
import Icon from "../../icon/Icon";
import { ArrowRight1_5px, ArrowRight2px, Sizes } from "../../icon/IconList";
import { useBrandStore } from "../BrandProvider";
import { SWIPER_LIMIT } from "./useBrandAllSearch";
const ProductSwiper = (param)=>{
    let { subject , count , items , routerChange  } = param;
    SwiperCore.use([
        Navigation,
        Pagination,
        Scrollbar,
        Autoplay,
        A11y,
        Grid,
        EffectCoverflow
    ]);
    const { isLoggedIn  } = useAuthStore();
    const name = useBrandStore((state)=>state.brand.name);
    const theme = useTheme();
    const swiperRef = useRef(null);
    const isMoreButton = useMemo(()=>count > SWIPER_LIMIT, [
        count
    ]);
    const { isMobile , isTablet  } = useWindowDimensions();
    return /*#__PURE__*/ _jsx(SwiperBox, {
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs(ManualCurationSectionWrapper, {
                style: {
                    margin: "0"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "header",
                        style: {
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Title, {
                                variant: "h5",
                                children: [
                                    /*#__PURE__*/ _jsxs("p", {
                                        style: {
                                            display: "flex",
                                            gap: "6px"
                                        },
                                        children: [
                                            "".concat(SubjectsWithString[subject], "자료"),
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    color: theme.palette.blue[400]
                                                },
                                                children: count
                                            })
                                        ]
                                    }),
                                    isMoreButton && !isTablet && /*#__PURE__*/ _jsx(Button, {
                                        variant: "text",
                                        onClick: ()=>{
                                            //mx-28 전체보기 버튼 클릭시
                                            mixpanelEvent("More Button Clicked", {
                                                "Button Type": "Brand Home Products",
                                                "Button Name": "전체보기",
                                                "Button Url": "".concat(BRAND_SEARCH_PAGE(name), "?subject=").concat(subject),
                                                "UI type": "text"
                                            });
                                            routerChange();
                                        },
                                        sx: {
                                            padding: "6px 12px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subtitle2",
                                            color: theme.palette.text.secondary,
                                            children: "전체보기"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(SwiperCustomButton, {
                                nextClassName: "manual-button-next-".concat(subject),
                                prevClassName: "manual-button-prev-".concat(subject)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Swiper, {
                        ref: swiperRef,
                        height: 382,
                        // width={224}
                        scrollbar: false,
                        slidesPerView: "auto",
                        spaceBetween: 20,
                        navigation: {
                            nextEl: ".manual-button-next-".concat(subject),
                            prevEl: ".manual-button-prev-".concat(subject)
                        },
                        children: [
                            items === null || items === void 0 ? void 0 : items.map((book, index)=>{
                                return /*#__PURE__*/ _jsx(SwiperSlide, {
                                    onClick: ()=>{
                                        //mx-189 브랜드 상품 모듈 클릭시
                                        mixpanelEvent("Brand Product Clicked", {
                                            "author Name": book.author,
                                            "Coupon Badge": book.isCouponAvailable,
                                            "Review Badge": book.rating,
                                            isLoggedIn: isLoggedIn,
                                            price: book.price,
                                            productId: book.id,
                                            productTitle: book.title,
                                            productType: "handout",
                                            subject: subject,
                                            "Brand Name": book.author
                                        });
                                    },
                                    style: {
                                        flexShrink: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(BookCard, {
                                        book: book,
                                        index: index,
                                        positionType: "curation",
                                        mixpanelPosition: "브랜드홈"
                                    }, "manual-book-info-".concat(index))
                                }, "item-".concat(index));
                            }),
                            isMoreButton && /*#__PURE__*/ _jsx(SwiperSlide, {
                                onClick: ()=>{
                                    //mx-28 전체보기 버튼 클릭시
                                    mixpanelEvent("More Button Clicked", {
                                        "Button Type": "Brand Home Products",
                                        "Button Name": "전체보기",
                                        "Button Url": "".concat(BRAND_SEARCH_PAGE(name), "?subject=").concat(subject),
                                        "UI type": "icon"
                                    });
                                    routerChange();
                                },
                                style: {
                                    flexShrink: 1
                                },
                                children: /*#__PURE__*/ _jsxs(AllButton, {
                                    role: "link",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            children: /*#__PURE__*/ _jsx(Icon, {
                                                icon: ArrowRight2px,
                                                size: Sizes.medium,
                                                color: theme.palette.blackAndWhite.white
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subtitle1",
                                            children: "전체 보기"
                                        })
                                    ]
                                })
                            }, "item-".concat(items.length + 1))
                        ]
                    }),
                    isTablet && /*#__PURE__*/ _jsx(Button, {
                        variant: "strokeSecondary",
                        label: "전체보기",
                        endIcon: /*#__PURE__*/ _jsx(Icon, {
                            icon: ArrowRight1_5px,
                            size: Sizes.small
                        }),
                        color: "secondary",
                        onClick: ()=>{
                            //mx-28 전체보기 버튼 클릭시
                            mixpanelEvent("More Button Clicked", {
                                "Button Type": "Brand Home Products",
                                "Button Name": "전체보기",
                                "Button Url": "".concat(BRAND_SEARCH_PAGE(name), "?subject=").concat(subject),
                                "UI type": "text"
                            });
                            routerChange();
                        },
                        sx: (theme)=>({
                                ...theme.typography.subtitle1,
                                color: theme.palette.text.secondary,
                                outlineColor: theme.palette.text.secondary,
                                margin: "24px 32px",
                                width: "fill-available",
                                [theme.breakpoints.down("sm")]: {
                                    margin: "24px 20px"
                                }
                            })
                    })
                ]
            }, "manual-".concat(subject))
        })
    });
};
const SwiperBox = styled("div")((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "824px",
        // margin: '40px 0',
        ".book-info-wrapper": {
            width: "191px !important",
            [theme.breakpoints.down("lg")]: {
                width: "224px !important"
            },
            [theme.breakpoints.down("sm")]: {
                width: "150px !important"
            }
        },
        ".header": {
            [theme.breakpoints.down("lg")]: {
                margin: "0 32px"
            },
            [theme.breakpoints.down("sm")]: {
                margin: "0 20px"
            }
        },
        ".swiper": {
            [theme.breakpoints.down("lg")]: {
                paddingLeft: "32px",
                paddingRight: "32px"
            },
            [theme.breakpoints.down("sm")]: {
                paddingLeft: "20px",
                paddingRight: "20px"
            }
        },
        [theme.breakpoints.down("lg")]: {
            maxWidth: "100%"
        },
        [theme.breakpoints.down("sm")]: {
        }
    };
});
const Title = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    };
});
const AllButton = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        minWidth: "191px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        marginRight: "20px",
        "&:hover": {
            borderRadius: "6px",
            backgroundColor: "rgba(169, 175, 199, 0.20)"
        },
        p: {
            display: "flex",
            width: "fit-content",
            borderRadius: "50px",
            backgroundColor: theme.palette.text.primary,
            padding: "12px"
        },
        [theme.breakpoints.down("lg")]: {
            minWidth: "224px"
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "150px",
            marginRight: "12px"
        }
    };
});
export default ProductSwiper;
